import { motion } from 'framer-motion';
import { Box } from '@chakra-ui/react';
import { pageTransition, pageVariants } from '../../config/animatePagesConfig';

export const PageTransition = ({ children }) => (
  <Box
    as={motion.div}
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}>
    {children}
  </Box>
);
